import configureModel from './configureModel';
import informationModel from './../components/informationModel';
import previewModel from './previewFrom/previewModel.vue';
import { groupList, templateGroupStatus, templateGroupStatusInfo, delTemplateGroup } from './request';
export default {
  components: {
    configureModel,
    informationModel,
    previewModel
  },
  data() {
    return {
      form: {},
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        key: '1',
        align: 'center',
        width: 100,
        scopedSlots: {
          customRender: 'index'
        }
      }, {
        slots: {
          title: '模版组名称'
        },
        dataIndex: 'name',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '状态'
        },
        dataIndex: 'status',
        key: '7',
        align: 'center',
        scopedSlots: {
          customRender: 'status'
        },
        width: 100
      }, {
        slots: {
          title: '创建时间'
        },
        dataIndex: 'createAt',
        key: '5',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        width: 220,
        key: '6',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      data: [],
      configureShow: false,
      informationShow: false,
      previewShow: false
    };
  },
  created() {
    this.getDataFun();
  },
  methods: {
    async getDataFun() {
      const {
        items,
        totalNum
      } = await groupList(Object.assign(this.form, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      }));
      this.data = items;
      this.pagination.total = totalNum;
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    handleEdit(val) {
      this.configureShow = true;
      this.$nextTick(() => {
        this.$refs.configureRef.init(val);
      });
    },
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    async checkedFun(val) {
      if (!this.isAuth('home.templateGroupStatus')) {
        this.$message.error(this.$t('暂无权限'));
        return false;
      }
      if (val.status == 1) {
        const res = await templateGroupStatusInfo({
          templateGroupId: val.id
        });
        if (res.length != 0) {
          this.informationShow = true;
          this.$nextTick(() => {
            this.$refs.informationRef.init(res, 3);
          });
          return false;
        }
      }
      await templateGroupStatus({
        templateGroupId: val.id,
        status: val.status == 1 ? 0 : 1
      });
      this.$message.success(this.$t('修改成功'));
      this.getDataFun();
    },
    handleDelete(val) {
      let _this = this;
      this.$alert(_this.$t('是否确认删除该模版组？'), {
        confirmButtonText: _this.$t('确定')
      }).then(() => {
        delTemplateGroup({
          templateGroupId: val.id
        }).then(res => {
          _this.$message.success(_this.$t('删除成功'));
          _this.getDataFun();
        });
      });
    },
    handlePreview(val) {
      this.previewShow = true;
      this.$nextTick(() => {
        this.$refs.previewRef.init(val.templateCongfig);
      });
    }
  }
};